 

import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const notificationsRoutes: RouteObject[] = [
  {
    path: 'NTF/*',
    children: [
      // HomePage كان نفس صفحة Index
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/NTX/Notifications/Index/Index')) },

      { path: 'Notifications', lazy: lazyRoute(() => import('../../pages/NTX/Notifications/Index/Index')) },
      {
        path: 'Notifications/AddNotifications',
        lazy: lazyRoute(() => import('../../pages/NTX/Notifications/Add/AddNotifications'))
      },
      {
        path: 'Notifications/:id/UpdateNotifications',
        lazy: lazyRoute(() => import('../../pages/NTX/Notifications/Update/UpdateNotifications'))
      }
    ]
  }
];

export default notificationsRoutes;
